import { Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import ReferenceQuestionnaire from './ReferenceQuestionnaire';
import { CustomDateInput } from '_components/CustomDateInput';

const ReferenceSection = ({
  key,
  referenceData,
  position,
  index,
  register,
  control,
  errors,
}) => {
  const referenceFields = [
    { label: 'Employer', value: referenceData?.last_employee },
    { label: 'Position Held', value: referenceData?.position },
    { label: 'Supervisor', value: referenceData?.supervisor_name },
    { label: 'Cell Phone', value: referenceData?.telephone },
  ];

  return (
    <Row key={key} className='show-grid interview__grid'>
      <div className='interview__head'>
        <h1>
          Reference #{index + 1}
        </h1>
      </div>

      <Col className='col_table'>
        <div className='interview__wrap'>
          <table className='ref_table'>
            <tbody>
              {referenceFields.map(({ label, value }) => (
                <tr key={label}>
                  <td>{label}</td>
                  <td>{value || '-'}</td>
                </tr>
              ))}

              <tr>
                <td>Verified</td>
                <td>
                  <div className='checkbox_wrap'>
                    <input
                      type='checkbox'
                      {...register(`verified_check_${position}`)}
                      className={`checkbox_input ${
                        errors?.[`verified_check_${position}`]?.message
                          ? 'error'
                          : ''
                      }`}
                    />
                    <label className='checkbox_label'></label>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Verified Date</td>
                <td>
                  <div className='verified_date'>
                    <Controller
                      control={control}
                      name={`verified_${position}_date`}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker
                          className='datepicker_ref'
                          placeholderText='Date'
                          ref={ref}
                          onChange={onChange}
                          onBlur={onBlur}
                          selected={value}
                          showMonthDropdown
                          showYearDropdown
                          maxDate={moment(new Date())}
                          customInput={<CustomDateInput />}
                        />
                      )}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Col>

      <ReferenceQuestionnaire
        position={position}
        register={register}
        errors={errors}
      />
    </Row>
  );
};

export default ReferenceSection;
